export default __webpack_public_path__ + "static/media/enConstruccion.35198505.svg";